import type { RouteLocationRaw, Router } from 'vue-router';

import { JobDetailsPageSource } from './jobDetailsPageSource';

/**
 * Named-route location for the sitter-facing job details page.
 */
export function getJobDetailsLocation(jobId: string): RouteLocationRaw {
  return {
    name: 'JobDetails',
    params: { id: jobId },
  };
}

/**
 * Absolute URL for sharing a job with sitters (same destination as invite admin messages).
 * Resolved through Vue Router so the path stays in sync with the named JobDetails route.
 */
export function getJobDetailsUrl(
  jobId: string,
  router: Pick<Router, 'resolve'>,
  origin: string = window.location.origin
): string {
  const { href } = router.resolve(getJobDetailsLocation(jobId));
  return new URL(href, origin).href;
}

/**
 * Router location for a parent previewing their job as sitters see it.
 */
export function getParentPreviewJobDetailsLocation(jobId: string): RouteLocationRaw {
  return {
    name: 'JobDetails',
    params: { id: jobId },
    query: { source: JobDetailsPageSource.ParentPreview },
  };
}
